import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_74c5b1b9 from '../styles/Dialog.module.less.js';
import DialogContext from './DialogContext.js';

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Content>content</Dialog>
 * ```
 */
const Content = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_74c5b1b9);
    const { fullscreen } = React.useContext(DialogContext);
    const classNames = cx(className, 'content', {
        fullscreen,
    });
    return (React.createElement("div", { ref: ref, className: classNames, ...restProps }, children));
});
Content.defaultProps = {};
Content.displayName = 'Content';

export { Content };
//# sourceMappingURL=Content.js.map
